<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Usuario' : 'Crear Nuevo Usuario' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre Completo</mat-label>
            <input matInput formControlName="displayName" class="text-lg text-white bg-blue-primary" cdkFocusInitial>
            <mat-error  *ngIf="displayNameControl?.invalid && (displayNameControl?.dirty || displayNameControl?.touched)">
                <span *ngIf="displayNameControl?.errors?.['required']">El nombre es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Correo Electrónico</mat-label>
            <input matInput type="email" formControlName="email" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)">
                <span *ngIf="emailControl?.errors?.['required']">El correo electrónico es requerido.</span>
                <span *ngIf="emailControl?.errors?.['email']">Ingrese un formato de correo electrónico válido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4">
            <mat-label class="text-gray text-lg">Contraseña</mat-label>
            <div class="relative">
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" [required]="!isEditMode">
                <button matIconButton (click)="togglePasswordVisibility()" type="button" class="password-toggle right-0">
                    <mat-icon class="text-orange">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </div>
            <mat-error *ngIf="passwordControl?.invalid && (passwordControl?.dirty || passwordControl?.touched)">
                <span *ngIf="passwordControl?.errors?.['required']" class="block">La contraseña es requerida</span>
                <span *ngIf="passwordControl?.errors?.['minLength']" class="block">La contraseña debe tener al menos {{ passwordControl?.errors?.['minLength']?.requiredLength }} caracteres.</span>
                <span *ngIf="passwordControl?.errors?.['hasLowercase']" class="block">La contraseña debe contener al menos una letra minúscula.</span>
                <span *ngIf="passwordControl?.errors?.['hasUppercase']" class="block">La contraseña debe contener al menos una letra mayúscula.</span>
                <span *ngIf="passwordControl?.errors?.['hasNumeric']" class="block">La contraseña debe contener al menos un número.</span>
                <span *ngIf="passwordControl?.errors?.['hasSpecial']" class="block">La contraseña debe contener al menos un caracter especial.</span>
            </mat-error>
        </mat-form-field>
        <div class="mb-4">
            <h3 class="text-gray text-sm">Asignación de Permisos</h3>
            <div class="flex items-end gap-2">
                <mat-form-field floatLabel="always" class="flex-grow">
                    <mat-label class="text-gray text-lg">Seleccionar Rol</mat-label>
                    <input matInput [formControl]="roleFilterControl" [matAutocomplete]="autoRole" placeholder="Buscar y seleccionar rol">
                    <mat-autocomplete #autoRole="matAutocomplete" [displayWith]="displayRoleName">
                        <mat-option *ngFor="let role of filteredRoles | async" [value]="role" >{{role.name}}</mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="roleFilterControl.invalid && (roleFilterControl.dirty || roleFilterControl.touched)">
                        <span *ngIf="roleFilterControl.errors?.['notARoleObject']">Por favor, seleccione un rol de la lista.</span>
                    </mat-error>
                </mat-form-field>
                <button matIconButton type="button" [disabled]="!(typeof roleFilterControl.value === 'object' && roleFilterControl.value !== null)" (click)="onAddRole()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <div formArrayName="roleIds" class="mb-4">
            <div *ngFor="let roleControl of assignedRolesControl.controls; let i = index" [formGroupName]="i" class="flex items-center justify-between pl-4 mb-2 border border-white rounded-sm">
                <span>{{ roleControl.get('name')?.value }}</span>
                <button matIconButton (click)="onRemoveRole(i); $event.stopPropagation()" aria-label="Eliminar rol">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        <mat-error *ngIf="assignedRolesControl.invalid && (assignedRolesControl.dirty || assignedRolesControl.touched)" class="mb-4">
            <span *ngIf="assignedRolesControl.errors?.['required']">Debes agregar un rol por lo menos.</span>
        </mat-error>
        <mat-slide-toggle formControlName="disabled" class="mb-4">
            Activo
        </mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>
